<template>
	<div>
		<v-row no-gutters class="editor_top_bar" style="height: 70px; background: #fcfcfd; z-index: 3">
			<v-col cols="12">
				<BlockEditorTopHeader :showParams="true" :integrationSelector="false" headerIcons="link-clicked" />
			</v-col>
		</v-row>
		<div class="px-6 fields">
			<v-row no-gutters class="text-left fif px-0 pt-2">
				<v-col cols="12" class="text-left" style="position: relative">
					<div class="input-label flex-space-between--center">
						<v-row justify="center">
							<v-col class="text-left">
								<h3>Incoming webhook url</h3>
							</v-col>
							<v-col cols="4" class="justify-center">
								<v-btn height="22" width="75" class="set_btn" color="#DBE1E7" @click="copyText(webhookURL)">Copy URL</v-btn>
							</v-col>
						</v-row>
					</div>
					<div>
						<v-text-field
							style="z-index: 2; font-size: 12px"
							readonly
							:value="webhookURL"
							height="52"
							class="param_field"
							color="primary"
							outlined
							single-line
							@focus="$event.target.select()"
						>
						</v-text-field>
					</div>
					<div v-if="!waitingForSampleData" class="text-center">
						<CTAButton @click="setWaitingForSampleData">Enter test mode</CTAButton>
					</div>
					<div v-else class="text-center">
						<v-progress-circular indeterminate color="primary"></v-progress-circular> <br />
						Send data to the webhook url - the status will updated automatically
					</div>
				</v-col>
			</v-row>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import { mapActionsShorthand } from '@/store/utils/mappers';
import BlockEditorTopHeader from '@/components/BlockEditor/BlockEditorTopHeader';
import { editNode } from '@/store/modules/selectedNode/getters';
import { getNode } from '@/store/modules/nodes/getters';
import {
	setWaitingForSampleData as setFlowWaitingForSampleData,
	fetchIsWaitingForSampleData as getWorkflowWaitingForSampleData,
} from '@/store/modules/workflows/actions';
import { WAITING_FLAG_TYPES } from '@/utils/workflow-service.const';

export default {
	name: 'CloudWorkflowBlock',
	components: {
		BlockEditorTopHeader,
	},
	computed: {
		...mapGetters('selectedWorkflow', ['editWorkflow']),
		...mapGetters('main', ['appApiURL']),
		...mapGetters([getNode.fullPath, editNode.fullPath]),
		selectedNode() {
			return this[getNode.fullPath](this[editNode.fullPath].id); // Without this - the data won't be reactive
		},
		webhookURL() {
			return `${this.appApiURL}incoming/webhooks/${this.editWorkflow.hash}/`;
		},
		testResults() {
			return this.selectedNode && this.selectedNode.test_result;
		},
	},
	methods: {
		...mapActionsShorthand({ setFlowWaitingForSampleData, getWorkflowWaitingForSampleData }),
		copyText(text) {
			navigator.clipboard.writeText(text);
		},
		async getSampleDataState() {
			this.waitingForSampleData = await this.getWorkflowWaitingForSampleData({
				id: this.editWorkflow.id,
				waiting_type: WAITING_FLAG_TYPES.AUTOMATION_SAMPLE,
			});
			if (this.waitingForSampleData) {
				this.startTimer();
			}
		},
		async setWaitingForSampleData() {
			await this.setFlowWaitingForSampleData({
				id: this.editWorkflow.id,
				is_waiting: true,
				waiting_type: WAITING_FLAG_TYPES.AUTOMATION_SAMPLE,
			});
			this.waitingForSampleData = true;
			this.startTimer();
		},
		startTimer() {
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.waitingForSampleData = false;
			}, 1000 * 60 * 3);
		},
	},
	mounted() {
		this.getSampleDataState();
	},
	watch: {
		testResults: {
			handler(newV, oldV) {
				if (newV && newV !== oldV) {
					this.waitingForSampleData = false;
					clearTimeout(this.timer);
				}
			},
			deep: true,
		},
	},
	data: () => ({
		waitingForSampleData: false,
		timer: null,
	}),
};
</script>
<style scoped></style>
